import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConfiguration } from '@klubovna/api-client';
import { posFavouritesControllerToggleFavourite, PosFavouritesControllerToggleFavourite$Params } from '@klubovna/api-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PosFavouritesApiService {
  private http = inject(HttpClient);
  private apiConfig = inject(ApiConfiguration);
  private rootUrl = this.apiConfig.rootUrl;

  toggleFavourite(params: PosFavouritesControllerToggleFavourite$Params): Observable<void> {
    return posFavouritesControllerToggleFavourite(this.http, this.rootUrl, params).pipe(
      map(() => undefined),
    );
  }
}

